import { apiClient } from './apiClient';

const createApp = async (payload) => {
  return await apiClient.post_form('/app', payload);
};

const fetchApps = async (payload) => {
  return await apiClient.get('/apps', payload);
};

const updateApp = async (id, payload) => {
  return await apiClient.patch_form(`/app/${id}`, payload);
};

const deleteApp = async (id) => {
  return await apiClient.delete_req(`/app/${id}`);
};

export const appsApi = {
  createApp,
  fetchApps,
  updateApp,
  deleteApp
};
